import React from "react"
import styled from "styled-components"

import Icon, {IconTypes} from "@irati/ui/src/Icon"

const StyledLabel = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: initial;
`

interface RowProps {
  isFocused: boolean,
  isDisabled?: boolean
}

const FlexRow = styled.div<RowProps>`
  align-items: center;
  justify-content: space-between;
  background-color: ${({theme, isFocused}) => (isFocused ? theme.colors.utility.highlight : "none")};
  display: flex;
  padding: ${({theme}) => theme.spacing.oneAndHalf};
  &:hover {
    background-color: ${({theme, isDisabled}) => !isDisabled && theme.colors.utility.highlight};
  }
`

const CountriesNotOnListOption = ({
  innerRef,
  innerProps,
  label,
  isFocused,
  isDisabled
}: {
  innerRef: any,
  innerProps: any,
  data: any,
  selectProps: any,
  label: string,
  isFocused: boolean,
  isDisabled: boolean
}) => {
  return (
    <FlexRow ref={innerRef} {...innerProps} isFocused={isFocused} isDisabled={isDisabled}>
      <StyledLabel>{label}</StyledLabel>
      <Icon icon={IconTypes.plus} size={10} />
    </FlexRow>
  )
}

export default CountriesNotOnListOption
